/* Verbatim port of renderDossier from service/review/index.html
 * (~3293-3298) — §8 Appendix's "Research dossier" block.
 *
 * PARAMETERIZED (rule a): reads the global STATE (STATE.dossier) — takes
 * `state: AppPayloadState` as an explicit first parameter.
 *
 * F3: innerHTML → lit render(). This is the wave's canonical unsafeHTML
 * site (convention #11) — renderMarkdown returns an HTML STRING (tables,
 * headings, links, bold), not plain text, so it can't go through a normal
 * escaping child binding without visibly breaking every dossier.
 */
import { html, render } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { renderMarkdown } from './markdown.ts';
import type { AppPayloadState } from '../derive/state-shape.ts';

export function renderDossier(state: AppPayloadState): void {
  const el = document.getElementById('dossierBody')!;
  if (state.dossier && state.dossier.replace(/```json[\s\S]*?```/g,'').trim().length > 40){
    // UNSAFE-HTML JUSTIFICATION: input is renderMarkdown(state.dossier)
    // (markdown.ts) — its own `inline()` helper escapes every text run via
    // lib/format.ts's esc() BEFORE applying its bold/link regex
    // substitutions, so the only unescaped markup reaching the DOM is what
    // markdown.ts itself introduces (<table>/<tr>/<td>, <h1-3>, <ul>/<li>,
    // <strong>, <a href> against an http(s)-only pattern) — never raw
    // payload text passes through unescaped. state.dossier is the research
    // agent's own narrative output (server-generated), the same trust
    // boundary as the rest of this hub's payload.
    render(html`${unsafeHTML(renderMarkdown(state.dossier))}`, el);
  } else render(html`<p style="color:var(--muted);font-size:13px">No narrative dossier in this run.</p>`, el);
}
